module.exports = __webpack_public_path__ + "assets/img/plugin_detail.305d8359.jpg";